import React, { FC } from 'react';
import { BubbleStyled } from '../../TimeGrid.styles';
import { AllieFileIcon, AllieZapIcon } from '../../../../../styling/icons';
import { Color } from '@ionic/core';

export enum ModulesIcon {
  quality = 'quality',
  qualityManual = 'qualityManual',
}

const PADDING_ICON = 9;

interface BubbleProps {
  module: keyof typeof ModulesIcon;
  color: Color;
  onClick: () => void;
  className?: string;
  size: number;
}

export const Bubble: FC<BubbleProps> = ({ module, color, className, onClick, size }) => {
  const mapIconComponent = {
    [ModulesIcon.quality]: AllieZapIcon,
    [ModulesIcon.qualityManual]: AllieFileIcon,
  };

  const sizeWithoutPadding = size - (PADDING_ICON * 2);

  return (
    <BubbleStyled
      onClick={onClick}
      className={className}
      style={{ height: size, width: size }}
    >
      {React.createElement(mapIconComponent[module], {
        color: 'var(--allie-color-secondary-50)',
        style: { fontSize: sizeWithoutPadding },
        display: 'contents',
      })}
    </BubbleStyled>
  );
};
